import React from "react";

import { useTranslation } from "@common/hooks/translation";
import NumericInput from "@common/components/numericInput";

export const PinForm = ({ form, setForm, errors }) => {
  const t = useTranslation();

  return (
    <>
      <div className="info-row">
        <p className="info-row-text">{t("Please SET A PIN CODE")}</p>
      </div>
      <div className="input-container">
        <div className="label-row">
          <p className="label-text">{t("PIN Code")}</p>
        </div>
        <div className="input-row">
          <NumericInput
            className="numeric-input"
            onChange={(val) => setForm({ ...form, pin: val })}
            value={form.pin}
            type="password"
            maxLength={4}
          />
        </div>
        {errors.pin && (
          <div className="error-row" style={{ display: "" }}>
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t(errors.pin)}</p>
          </div>
        )}
        <div className="label-row">
          <p className="label-text">{t("CONFIRM PIN CODE")}</p>
        </div>
        <div className="input-row">
          <NumericInput
            className="numeric-input"
            onChange={(val) => setForm({ ...form, confirmPin: val })}
            value={form.confirmPin}
            type="password"
            maxLength={4}
          />
        </div>
        {errors.confirmPin && (
          <div className="error-row" style={{ display: "" }}>
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t(errors.confirmPin)}</p>
          </div>
        )}
      </div>
    </>
  );
};
